import { Link, Tooltip as MUITooltip } from '@mui/material';
import { clsx } from 'clsx';

import { TaskField } from '@atom/types/task';
import {
  CustomFieldView,
  getTaskFieldWidth,
} from '@atom/utilities/taskUtilities';

import classes from './taskFields.module.css';

interface Props {
  field: TaskField;
  customFieldView: CustomFieldView;
}

const TaskHyperlinkField = ({ field, customFieldView }: Props) => {
  const containerWidth = {
    maxWidth: getTaskFieldWidth(customFieldView),
  };

  return (
    <div className={classes.fieldContainer} style={containerWidth}>
      <div className={clsx(classes.fieldTitle, classes.hyperlinkTitle)}>
        {field.title}
      </div>
      <MUITooltip title={field.hyperlink}>
        <Link href={field.hyperlink} target="_blank">
          {field.value}
        </Link>
      </MUITooltip>
    </div>
  );
};

export default TaskHyperlinkField;
